import { ModalType } from 'containers/Modal/ModalType';
import { useMainSelector } from 'modules/main/store/hooks/useMainSelector';

export function useCurrentModalType(): ModalType | null | undefined {
  return useMainSelector((state) => state.modal.type);
}
